import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Upload, FileSpreadsheet, CheckCircle2, ShieldCheck, Database,
  ArrowRight, Info,
} from "lucide-react";
import CsvImportModal from "../components/CsvImportModal";

export default function Importa() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  return (
    <div data-testid="importa-page">
      <div className="flex items-start gap-3 mb-6">
        <Upload size={28} color="var(--mv-primary)"/>
        <div>
          <div className="h-display">Importa liste lead</div>
          <div className="text-muted mt-1">
            Carica liste di contatti già acquistate da portali o esportate da altri strumenti, e portale direttamente nel CRM.
          </div>
        </div>
      </div>

      {/* Big CTA */}
      <div className="card mb-6" style={{padding: 36, textAlign: "center",
        background: "linear-gradient(135deg, #fff7ed 0%, #ffffff 100%)",
        borderLeft: "4px solid var(--mv-primary)"}}>
        <FileSpreadsheet size={56} color="var(--mv-primary)" style={{margin: "0 auto 16px"}}/>
        <div style={{fontSize: 22, fontWeight: 700, marginBottom: 8}}>
          Importa una lista in 4 step
        </div>
        <div className="text-muted mb-4" style={{maxWidth: 560, margin: "0 auto 20px"}}>
          Supporta CSV con intestazioni in italiano o inglese, dedupe automatico per dominio/email/P.IVA,
          mappatura colonne intelligente e verifica email opzionale.
        </div>
        <button onClick={()=>setShowModal(true)} className="btn btn-primary"
          data-testid="importa-cta-btn"
          style={{fontSize: 16, padding: "12px 28px"}}>
          <Upload size={16}/> Avvia import CSV
          <ArrowRight size={16}/>
        </button>
      </div>

      {/* Feature cards */}
      <div className="grid gap-4" style={{gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))"}}>
        <FeatureCard
          icon={<Database size={20} color="var(--mv-primary)"/>}
          title="Mapping colonne intelligente"
          description="Riconosce automaticamente colonne in italiano e inglese: Ragione Sociale, Email, Sito Web, P.IVA, Telefono, Città, Provincia, Settore, Titolare, ATECO e altri 6 campi."
        />
        <FeatureCard
          icon={<CheckCircle2 size={20} color="var(--mv-success)"/>}
          title="Dedupe automatico"
          description="Controlla se l'azienda è già nel CRM (matching su sito/email/P.IVA) e se sì, integra solo i campi mancanti senza sovrascrivere quelli esistenti."
        />
        <FeatureCard
          icon={<ShieldCheck size={20} color="#1e40af"/>}
          title="Verifica email opzionale"
          description="Se la lista non è già stata verificata, attiva il toggle ZeroBounce in fase di import per controllare la deliverability di ogni email e filtrare automaticamente quelle non valide."
        />
      </div>

      {/* Tips card */}
      <div className="card mt-6" style={{padding: 18, background: "#fafafa"}}>
        <div className="flex items-start gap-2 mb-3">
          <Info size={18} color="var(--mv-primary)" style={{marginTop: 2}}/>
          <div style={{fontWeight: 600, fontSize: 14}}>Suggerimenti per il file CSV</div>
        </div>
        <ul className="text-small text-muted" style={{lineHeight: 1.8, paddingLeft: 20, margin: 0}}>
          <li>Formato accettato: <strong>CSV UTF-8</strong> (se hai un file <code>.xlsx</code> aprilo in Excel/Numbers e salvalo come "CSV UTF-8")</li>
          <li>Massimo <strong>5 MB</strong> per file (~30.000 righe). Per file più grandi, dividilo in più parti.</li>
          <li>Delimiter <code>;</code> oppure <code>,</code> riconosciuti automaticamente.</li>
          <li>La <strong>prima riga</strong> deve contenere le intestazioni delle colonne.</li>
          <li>Servono almeno: <strong>Ragione Sociale</strong> + 1 tra (Email / Sito web / P.IVA) per identificare l'azienda.</li>
          <li>Se la lista è già stata verificata da un altro tool (es. Hunter, NeverBounce), <strong>disattiva ZeroBounce</strong> al passo 3 per risparmiare crediti.</li>
        </ul>
      </div>

      {showModal && (
        <CsvImportModal
          onClose={()=>setShowModal(false)}
          onImported={()=>{
            setShowModal(false);
            // Optionally navigate to lists
            navigate("/liste");
          }}
        />
      )}
    </div>
  );
}

function FeatureCard({ icon, title, description }) {
  return (
    <div className="card" style={{padding: 18}}>
      <div className="flex items-center gap-2 mb-2">
        {icon}
        <div style={{fontWeight: 600}}>{title}</div>
      </div>
      <div className="text-small text-muted" style={{lineHeight: 1.6}}>
        {description}
      </div>
    </div>
  );
}
